Object.defineProperty(exports, "__esModule", {
  value: true,
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.httpGetMethod = "GET";
exports.httpPostMethod = "POST";
exports.httpPutMethod = "PUT";
exports.httpDeleteMethod = "DELETE";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "Promotions";
exports.labelBodyText = "Promotions Body";
exports.btnExampleTitle = "CLICK ME";

exports.ApiUrls = {
  promotionsList: "bx_block_promotions/promotions",
  promotionShow: "bx_block_promotions/promotions/",
  promotionCreate: "bx_block_promotions/promotions",
  promotionUpdate: "bx_block_promotions/promotions/",
  promotionDelete: "bx_block_promotions/promotions/",
  promotionTypes: "bx_block_promotions/promotion_types",
};

exports.Strings = {
  token: "token",
  promotionsList: {
    view: "View",
    edit: "Edit",
    active: "Active",
    deactivate: "Deactivate",
    pageTitle: "Promotions",
    addPromotion: "Add Promotions",
    noRecordFounds: "No promotions found",
    confirmDeactivate: "Confirm Deactivate",
    promotionDeactivated: "Promotion Deactivated",
    backToListing: "Back to Listing"
  }
};
// Customizable Area End